import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FieldType } from '@ngx-formly/core';
import { ExitTeamLeadsComponent } from 'src/app/immigration/components/exit-team-leads/exit-team-leads.component';

@Component({
  selector: 'eos-additional-team-detail-picker',
  templateUrl: './additional-team-detail-picker.component.html',
  styleUrls: ['./additional-team-detail-picker.component.css']
})
export class AdditionalTeamDetailPickerComponent extends FieldType implements OnInit {

  modalRef: any;
  country:any;
  candidateId:number;
  type:any;

  constructor(private modalService: NgbModal,
    public modal: NgbActiveModal,
    private activeRoute: ActivatedRoute,) {
    super();
    this.activeRoute.params.subscribe((routeParams) => {
      this.candidateId=routeParams.id;
      this.country=routeParams.country;
      this.type=routeParams.type;  
    });
  }

  ngOnInit() {
  }
  
  openPickerModel() {
    const picker = this.modalService.open(ExitTeamLeadsComponent, { windowClass: 'dark-modal' });
    this.modalRef = picker;
    picker.componentInstance.candidateId = this.candidateId;
    picker.componentInstance.visaType = this.type;
    picker.componentInstance.country = this.country;
    picker.componentInstance.inModal=true;
    picker.componentInstance.readOnly=true;
  }
}
